import { Navigate, Outlet } from 'react-router-dom';

export const RequireAuth = () => {
	const pxcUser = localStorage.getItem('pxcUser') || '';

	if (!pxcUser) return <Navigate to='/login' />;

	return <Outlet />;
};
